import React, { Component, useState, useTransition } from 'react';
import { Form } from '../common/Form';
import { useTranslation } from 'react-i18next';

export function CatForm(props)
{
	const {t} = useTranslation();
	const [cat,setCat] = useState(props.cat);

	const onValChange=(data)=>{
		console.log("onValChange:"+JSON.stringify(data));
		setCat(data);
		props.onChange(data);		
	}
	return(
		<Form id="formid" formData={cat} onChange={onValChange}
			fields={[
				{id:"code",ftype:"text",field:"code",label:t("Code")},
				{id:"name",ftype:"text",field:"name",label:t("Name")},
				{id:"descr",ftype:"textarea",field:"descr",label:t("Description")},
			]}>
		</Form>	
	);
}
export default CatForm;